import { ArrowDownTrayIcon, ArrowUpTrayIcon, CheckIcon } from "@heroicons/react/20/solid";
import { ClipboardDocumentListIcon } from "@heroicons/react/24/outline";
import { differenceInCalendarYears, getYear } from "date-fns";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { Actions as AUTHENTICATION_ACTIONS } from "../../store/actions/authenticationActions";

import { Actions as SALARY_CALCULATOR_ACTIONS } from "../../store/actions/salaryCalculatorActions";
import "../salaryCalc.css";
import { Link } from "react-router-dom";
const BuddyTail = "https://buddystorepdf.s3.eu-west-1.amazonaws.com/buddy-tail-white.png";
const BuddyTypography = "https://buddystorepdf.s3.eu-west-1.amazonaws.com/buddy-typography.png";

const years = [...Array(differenceInCalendarYears(new Date(), new Date(2018, 1, 1)) + 1)].map((item, index) => ({
	value: `${2018 + index}`,
	label: `${2018 + index}`,
}));

if (getYear(new Date()) == 2024) years.push({ value: "2025", label: "2025" });

function UseCompanySelector({ profile, organisations, loading, primaryColor, onSelect }) {
	const [selectedCompany, setSelectedCompany] = useState(null);

	if (profile)
		return (
			<Select
				className="w-full"
				isLoading={loading}
				isDisabled={loading}
				options={organisations}
				value={selectedCompany}
				placeholder="Select your company..."
				isClearable={true}
				onChange={(value) => {
					setSelectedCompany(value);
					if (onSelect) onSelect(value);
				}}
			/>
		);
	else {
		return (
			<a
				as={"button"}
				href={`https://www.buddy.hr/login?referrer=${window.location.href}`}
				className={`relative cursor-pointer py-2 shadow text-base w-full h-full flex justify-center items-center px-4 border border-transparent font-medium rounded-md text-white focus:outline-none transition duration-150 ease-in-out${
					primaryColor ? "" : " bg-orange-400 hover:bg-orange-500"
				}`}
				style={primaryColor && { backgroundColor: primaryColor }}
			>
				Sign In With Buddy
			</a>
		);
	}
}

const ColaCalculator = ({
	options,
	requestColaReport,
	error,
	saving,
	downloadLink,
	profile,
	loggedIn,
	downloadColaTemplate,
	uploadCola,
	downloadPDF,
	organisations,
	getAvailableOrganisations,
	jurisdiction,
}) => {
	const {
		primaryColor,
		backgroundColor,
		innerChartColours,
		outerChartColours,
		netColor,
		coverColor,
		poweredByTextColor,
		footerTextColor,
		logo,
	} = options || {};

	const [data, setData] = useState({
		noOfEmployees: "1-5",
		name: "",
		surname: "",
		phone: "",
		organisation: "",
		email: "",
	});

	const [steps, setSteps] = useState(0);
	const year = years?.[years?.length - 1]?.label;
	const [route, setRoute] = useState();

	useEffect(() => {
		if (!profile) return;

		getAvailableOrganisations();

		setData({
			...data,
			name: profile.givenName || profile.name,
			surname: profile.familyName || profile.surname,
			email: profile.email,
		});
	}, [profile?.id]);

	const handleChange = (event) => {
		setData({
			...data,
			[event.target.name]: event.target.value,
		});
	};

	const handleSubmit = (e) => {
		if ((!data.orgId ? false : !data.name || !data.surname || !data.email) || !data.organisation) return;
		requestColaReport({
			jurisdiction: jurisdiction ? jurisdiction.toUpperCase() : "MT",
			key: downloadLink,
			lead: data,
			branding: options,
			organisation: data.organisation,
			orgId: data.orgId,
			sendTo: options && options.sendTo,
			year,
		});
		setSteps(5);
		// TODO send email
	};

	const GeneratePDFReport = () => {
		return (
			<button
				className={`col-span-2 relative py-2 shadow text-base w-full h-full flex justify-center items-center px-4 border border-transparent font-medium rounded-md text-white focus:outline-none transition duration-150 ease-in-out${
					primaryColor ? "" : " bg-orange-400 hover:bg-orange-500"
				}`}
				style={primaryColor && { backgroundColor: primaryColor }}
				onClick={(event) => {
					event.preventDefault();
					handleSubmit();
				}}
				type="submit"
			>
				Generate Your PDF Report
				{steps < 5 ? (
					<ArrowDownTrayIcon className="absolute h-6 w-6 right-4" />
				) : (
					<svg
						className={`text-white inline-block animate-spin -ml-1 mr-3 h-5 w-5 absolute right-4`}
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
					>
						<circle
							className="opacity-25"
							cx="12"
							cy="12"
							r="10"
							stroke="currentColor"
							strokeWidth="4"
						></circle>
						<path
							className="opacity-75"
							fill="currentColor"
							d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
						></path>
					</svg>
				)}
			</button>
		);
	};

	return (
		<div className="buddy-hr-widget">
			<div className="col-span-12 grid md:grid-cols-7 lg:grid-cols-12">
				<div className="text-center mx-4 md:col-span-7 lg:col-span-5 lg:text-left lg:flex items-start">
					<div className="md:mt-0 md:col-span-2">
						<div
							className={`px-4 py-5 space-y-4 sm:p-6 rounded-md${backgroundColor ? "" : " bg-gray-100"}`}
							style={{ backgroundColor: backgroundColor }}
						>
							<h2 className="text-gray-700 font-extrabold text-3xl">
								Understand the impact of <br />
								<span
									className={`text-4xl ${primaryColor ? "" : `text-orange-500`}`}
									style={{ color: primaryColor }}
								>
									Budget{" "}
								</span>
								on your business in <br />
								<span
									className={`text-4xl ${primaryColor ? "" : `text-orange-500`}`}
									style={{ color: primaryColor }}
								>
									4&nbsp;
								</span>
								simple steps
							</h2>
							<div className="mt-6 mb-6">
								<div className="shadow rounded-md px-6 py-10 bg-white">
									{steps < 4 ? (
										<>
											<ul className="space-y-4">
												{[undefined, "Excel"].includes(route) && (
													<>
														<li className="flex items-start pr-4">
															<div className="flex-shrink-0">
																<h2 className="mr-2 px-2 py-2 text-gray-700 font-bold text-xl">
																	1.
																</h2>
															</div>
															<button
																className={`relative py-2 shadow text-base w-full h-full flex justify-center items-center px-4 border border-transparent font-medium rounded-md text-white focus:outline-none transition duration-150 ease-in-out${
																	primaryColor
																		? ""
																		: " bg-orange-400 hover:bg-orange-500"
																}`}
																style={
																	primaryColor && { backgroundColor: primaryColor }
																}
																onClick={() => {
																	downloadColaTemplate();
																	if (steps < 1) setSteps(1);
																	setRoute("Excel");
																}}
															>
																Download Template
																{steps < 1 ? (
																	<ArrowDownTrayIcon className="absolute h-6 w-6 right-4" />
																) : (
																	<CheckIcon className="absolute h-6 w-6 right-4" />
																)}
															</button>
														</li>
														<li className="flex items-start pr-4">
															<div className="flex-shrink-0">
																<h2 className="mr-2 px-2 py-2 text-gray-700 font-bold text-xl">
																	2.
																</h2>
															</div>
															<button
																className="relative shadow w-full h-full text-base text-center font-medium flex justify-center items-center rounded-md px-4 py-2 bg-gray-100 hover:bg-gray-200 transition duration-150 ease-in-out"
																onClick={() => {
																	if (steps < 2) setSteps(2);
																}}
															>
																Fill with your salary details
																{steps < 2 ? (
																	<ClipboardDocumentListIcon className="absolute h-6 w-6 right-4" />
																) : (
																	<CheckIcon className="absolute h-6 w-6 right-4" />
																)}
															</button>
														</li>
														<li className="flex items-start pr-4">
															<div className="flex-shrink-0">
																<h2 className="mr-2 px-2 py-2 text-gray-700 font-bold text-xl">
																	3.
																</h2>
															</div>
															<label
																className={`relative cursor-pointer py-2 shadow text-base w-full h-full flex justify-center items-center px-4 border border-transparent font-medium rounded-md text-white focus:outline-none transition duration-150 ease-in-out${
																	primaryColor
																		? ""
																		: " bg-orange-400 hover:bg-orange-500"
																}`}
																style={
																	primaryColor && { backgroundColor: primaryColor }
																}
																htmlFor="fileUpload"
															>
																Upload your file
																{steps < 3 ? (
																	<ArrowUpTrayIcon className="absolute h-6 w-6 right-4" />
																) : saving ? (
																	<svg
																		className={`text-white inline-block animate-spin -ml-1 mr-3 h-5 w-5 absolute right-4`}
																		xmlns="http://www.w3.org/2000/svg"
																		fill="none"
																		viewBox="0 0 24 24"
																	>
																		<circle
																			className="opacity-25"
																			cx="12"
																			cy="12"
																			r="10"
																			stroke="currentColor"
																			strokeWidth="4"
																		></circle>
																		<path
																			className="opacity-75"
																			fill="currentColor"
																			d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
																		></path>
																	</svg>
																) : (
																	<CheckIcon className="absolute h-6 w-6 right-4" />
																)}
															</label>
															<input
																style={{ display: "none" }}
																id="fileUpload"
																type="file"
																accept=".xlsx"
																onChange={(e) => {
																	const file = e.target.files[0]; // accesing file
																	console.debug(file);
																	if (file) uploadCola(file);
																	if (file && steps < 3) setSteps(3);
																	setRoute("Excel");
																}}
															/>
														</li>
														<li className="flex items-start pr-4">
															<div className="flex-shrink-0">
																<h2 className="mr-2 px-2 py-2 text-gray-700 font-bold text-xl">
																	4.
																</h2>
															</div>
															<button
																className={`relative shadow w-full h-full text-base text-center font-medium rounded-md flex justify-center items-center px-4 py-2 bg-gray-100 ${
																	steps < 3 && !downloadLink
																		? "cursor-not-allowed"
																		: "hover:bg-gray-200"
																} transition duration-150 ease-in-out`}
																onClick={() => {
																	if (steps < 4) setSteps(4);
																}}
																disabled={steps < 3 && !downloadLink && !data?.orgId}
															>
																Get your PDF Report
															</button>
														</li>
													</>
												)}

												{!route && (
													<li>
														<div class="relative flex py-5 items-center">
															<div
																className={`flex-grow border-t ${
																	primaryColor ? "" : "border-orange-400"
																}`}
															></div>
															<span className="flex-shrink mx-4 text-gray-400">OR</span>
															<div
																className={`flex-grow border-t ${
																	primaryColor ? "" : "border-orange-400"
																}`}
															></div>
														</div>
													</li>
												)}
												{[undefined, "Profile"].includes(route) && (
													<>
														<li className="flex items-start pr-4">
															<div className="flex-shrink-0">
																<h2 className="mr-2 px-2 py-2 text-gray-700 font-bold text-xl">
																	1.
																</h2>
															</div>
															<UseCompanySelector
																profile={loggedIn}
																organisations={organisations}
																onSelect={(selectedCompany) => {
																	setData({
																		...data,
																		organisation: selectedCompany?.label || "",
																		orgId: selectedCompany?.value || null,
																	});
																	setRoute(selectedCompany ? "Profile" : undefined);
																}}
																loading={saving}
																primaryColor={primaryColor}
															/>
														</li>
														<li className="flex items-start pr-4">
															<div className="flex-shrink-0">
																<h2 className="mr-2 px-2 py-2 text-gray-700 font-bold text-xl">
																	2.
																</h2>
															</div>
															{data?.orgId ? (
																<GeneratePDFReport />
															) : (
																<button
																	className={`relative shadow w-full h-full text-base text-center font-medium rounded-md flex justify-center items-center px-4 py-2 bg-gray-100 ${
																		steps < 3 && !downloadLink
																			? "cursor-not-allowed"
																			: "hover:bg-gray-200"
																	} transition duration-150 ease-in-out`}
																	onClick={() => {
																		if (steps < 4) setSteps(4);
																	}}
																	disabled={
																		steps < 3 && !downloadLink && !data?.orgId
																	}
																>
																	Get your PDF Report
																</button>
															)}
														</li>
													</>
												)}
											</ul>
										</>
									) : (
										<form handleSubmit={handleSubmit}>
											<div className="grid grid-cols-2 gap-4">
												<div className="col-span-1">
													<label
														htmlFor="name"
														className="sr-only"
													>
														Name
													</label>
													<div className="rounded-md shadow-sm">
														<input
															value={data.name}
															onChange={handleChange}
															name="name"
															id="name"
															disabled={data?.orgId}
															placeholder="Name"
															required
															className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
														/>
													</div>
												</div>

												<div className="col-span-1">
													<label
														htmlFor="surname"
														className="sr-only"
													>
														Surname
													</label>
													<div className="rounded-md shadow-sm">
														<input
															value={data.surname}
															onChange={handleChange}
															name="surname"
															id="surname"
															disabled={data?.orgId}
															placeholder="Surname"
															required
															className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
														/>
													</div>
												</div>

												<div className="col-span-2">
													<label
														htmlFor="email"
														className="sr-only"
													>
														Email
													</label>
													<div className="rounded-md shadow-sm">
														<input
															value={data.email}
															onChange={handleChange}
															name="email"
															id="email"
															disabled={data?.orgId}
															placeholder="Email"
															required
															className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
														/>
													</div>
												</div>

												<div className="col-span-2 items-center">
													<label
														htmlFor="organisation"
														className="sr-only"
													>
														Organisation
													</label>
													<div className="rounded-md shadow-sm">
														<input
															value={data.organisation}
															onChange={handleChange}
															name="organisation"
															id="organisation"
															disabled={data?.orgId}
															placeholder="Organisation"
															required
															className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
														/>
													</div>
												</div>

												{downloadPDF ? (
													<a
														className={`col-span-2 relative py-2 shadow text-base w-full h-full cursor-pointer flex justify-center items-center px-4 border border-transparent font-medium rounded-md text-white focus:outline-none transition duration-150 ease-in-out${
															primaryColor ? "" : " bg-orange-400 hover:bg-orange-500"
														}`}
														style={primaryColor && { backgroundColor: primaryColor }}
														onClick={() => {
															window.open(downloadPDF, "_blank");
															setSteps(6);
														}}
													>
														Download Your PDF Report
														{steps < 6 ? (
															<ArrowDownTrayIcon className="absolute h-6 w-6 right-4" />
														) : (
															<CheckIcon className="absolute h-6 w-6 right-4" />
														)}
													</a>
												) : (
													<GeneratePDFReport />
												)}
											</div>
										</form>
									)}
								</div>
							</div>
						</div>
						<div className="text-left">
							<p
								className={`text-xs mt-2${poweredByTextColor ? "" : " text-gray-200"}`}
								style={poweredByTextColor && { color: poweredByTextColor }}
							>
								Powered by{" "}
								<a
									className="hover:underline"
									target="_blank"
									href="https://www.buddy.hr"
								>
									Buddy - Cloud HR & Payroll Software.
								</a>
							</p>
							<p
								className={`text-xs mt-2${footerTextColor ? "" : " text-gray-400"}`}
								style={footerTextColor && { color: footerTextColor }}
							>
								The results presented by this payroll calculator are generated through the same system
								Buddy uses to calculate real payroll results.
							</p>
						</div>
					</div>
				</div>

				<div className="mt-4 lg:mt-0 md:col-span-7 lg:col-span-7 mx-4">
					<div
						className={`space-y-4 p-6 pb-0 rounded-md${backgroundColor ? "" : " bg-gray-100"}`}
						style={backgroundColor && { backgroundColor: backgroundColor }}
					>
						<div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
							<div
								className={`relative ${
									coverColor ? "" : "bg-orange-500"
								} rounded-lg col-span-1 mb-6 shadow`}
								style={{ background: coverColor, height: "28rem" }}
							>
								<img
									src={BuddyTail}
									className="object-cover absolute"
								/>
								<img
									src={logo ? logo : BuddyTypography}
									className="h-14 absolute top-12 left-8"
								/>
								<div className="text-white absolute top-48  left-8">
									<h2 className="text-2xl font-extrabold mb-4">
										{data.organisation?.replace(/\s/g, "") ? data.organisation : "Your Company"}
									</h2>
									<h2 className="text-xl font-extrabold tracking-tight">
										Budget <br />
										Impact Report
									</h2>
									<h3>{year}</h3>
								</div>
								{logo && (
									<img
										src={BuddyTypography}
										className="h-8 absolute bottom-4 right-6"
									/>
								)}
							</div>
							<div className="col-span-1">
								{true && (
									<div>
										<h3 className="text-xl font-bold text-gray-700 uppercase">
											Detailed Impact Report
										</h3>
										<ul
											className="text-sm mt-2 mb-2 font-normal"
											style={{
												listStyle: "disc",
												marginLeft: 40,
											}}
										>
											<li>Upload {parseInt(year) -1} Salary Data</li>
											<li>Annualised Wage bill for {year}</li>
											<li>Cost & Net Increases to pay</li>
											<li>Employee by Employee change breakdown</li>
											<li>Value of Public Holidays</li>
											<li>Value of Vacation and Sick Leave</li>
											<li>Cost of Productive Hours</li>
											<li>Average increase in Productive Hour Cost</li>
											<li>Definitions of Payroll Terminology</li>
										</ul>
									</div>
								)}
								<ol className="list-decimal pb-4 text-left">
									{
										jurisdiction === "uk" ?
											<>
												<li className="py-1 block text-xs text-gray-600 ">
													1. Presented results are for a full-time employees with default 1257L tax code; assuming all are opted into a pension scheme; and subject to class A NICs.
												</li>
												<li className="py-1 block text-xs text-gray-600 ">
													2. For GDPR purposes it is recommended that you use aliases or codes instead of
													actual employee names. Buddy will need to process the files provided, including
													any personal data included. Buddy is ISO27001 compliant and will treat your data
													with utmost security.
												</li>
											</>
										 : 	<>
												<li className="py-1 block text-xs text-gray-600">
													1. Weekly Allowance is Paid in March and September, Statutory Bonus is paid
													every June and December
												</li>
												<li className="py-1 block text-xs text-gray-600 ">
													2. Presented results are for a full-time employees with single tax rates. SSC
													class D contributions are estimated and may change upon final notice.
												</li>
												<li className="py-1 block text-xs text-gray-600 ">
													3. For GDPR purposes it is recommended that you use aliases or codes instead of
													actual employee names. Buddy will need to process the files provided, including
													any personal data included. Buddy is ISO27001 compliant and will treat your data
													with utmost security.
												</li>
											</>
									}

								</ol>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const net = state?.salaries?.net;

	const organisations = state?.my?.organisations
		?.filter?.((o) => ![true, "true", "yes"].includes(o.demo) && !String(o.name).includes("(Advisor)"))
		?.map((o) => ({
			label: o.name,
			value: o.id,
		}));

	const profile =
		state?.my?.profile || (localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData")));
	const options = {
		aboutBackground: "transparent",
		aboutBorder: "#2497bd",
		addressLine1: "5 Triq il-Ħuttaf, Mosta",
		addressLine2: "MST4601, MALTA.",
		description:
			"We’re a Malta-based HR consultancy firm specialising in Recruitment, HR Strategy, HR Outsourcing, Payroll Outsourcing and other services related to people management.",
		email: "info@quadconsultancy.com",
		footerTextColor: "rgb(55, 65, 81)",

		innerChartColours: [
			"#EA611C",
			"#B68D40",
			"#F4EBD0",
			"#122620",
			"#FAB300",
			"#D6AD60",
			"#22508A",
			"#FFD78C",
			"#000",
		],
		linkColor: "#2497bd",
		logo: "https://www.quadconsultancy.com/wp-content/uploads/2021/02/Quad-logo.png",
		name: "Quad Consultancy",
		netColor: "#66EE66",

		outerChartColours: ["#7F80EB", "#FB6090", "#DF362D", "#E57F84", "#2F5061", "#4297A0", "#B4F8C8", "#821D30"],
		phone: "+356 2099 4444",
		poweredByTextColor: "rgb(55, 65, 81)",
		primaryColor: "#83a113",
		coverColor: "#BBB",
		website: "www.quadconsultancy.com",
		websiteLink: "https://www.quadconsultancy.com",
	};

	return {
		saving: !!state.colaCalculator?.uploading,
		downloadLink: state.colaCalculator?.uploadResults,
		downloadPDF: state.colaCalculator?.downloadLink,
		organisations,
		profile,
		loggedIn: state?.my?.profile,
		// options,
		net,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getAvailableOrganisations: () => dispatch(AUTHENTICATION_ACTIONS.getAvailableOrganisations()),
	requestColaReport: (data) => dispatch(SALARY_CALCULATOR_ACTIONS.requestColaReport(data)),
	downloadColaTemplate: (data) => dispatch(SALARY_CALCULATOR_ACTIONS.downloadColaTemplate(data)),
	uploadCola: (file) => dispatch(SALARY_CALCULATOR_ACTIONS.uploadCola({ file })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ColaCalculator);
